import { Container, Center, VStack, Spinner, Text } from '@chakra-ui/react';

const LoadingState = () => {
  return (
    <Container maxW="container.xl" py={10}>
      <Center minH="400px">
        <VStack spacing={4}>
          <Spinner size="xl" color="blue.500" thickness="4px" />
          <Text color="gray.600" fontSize="lg">
            Loading documents...
          </Text>
        </VStack>
      </Center>
    </Container>
  );
};

export default LoadingState;
